module.exports = __webpack_public_path__ + "img/blog-2.e7d37522.webp";